import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconTipSvg } from "./IconTipSvg.mjs";
const IconTip = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconTipSvg, ...iconProps });
};
export {
  IconTip
};
